import { InspectionItemResult } from "src/app/types/inspection.type";
import { BuildServices, GenericRouteEvent, RouteEventAction, RouteEventActionColorMap, RouteEventActionFillMap, RouteEventActionTypeMap } from "./generic-route-event.model";
import { _NonServicePeriod } from '.';
import { CustomField } from "../custom-field.type";
import { CustomFormPage } from "src/app/pages/custom-form/custom-form.page";

export class CustomFieldInspection extends GenericRouteEvent {

  constructor(data: CustomField[], services: BuildServices) {
    super(services);
    this.value = data;
    this.headerInfo.type = 'LABEL.additionalQuestions';
    this.actions = this.getActions();
    this.type = 'custom-form';
    this.completed = false;
  }

  public getActions(): RouteEventAction[] {
    return [
      {
        show: !this.completed,
        type: RouteEventActionTypeMap.perform,
        label: this.translateSvc.translate('ACTION.start'),
        icon: '',
        color: RouteEventActionColorMap.primary,
        fill: RouteEventActionFillMap.solid,
        preview: false,
        drivingMode: false,
        disabled: false,
        fn: () => this.start(),
      },
    ].filter(action => action.show);
  }


  private submitCustomFormResults = (customFormResults: InspectionItemResult[]) => new Promise(async resolve => {
    this.completed = true;
    await this.dispatchSvc.addCustomFormResult(customFormResults);
    await this.modalController.dismiss();
  });

  protected async start() {
    if (!(<CustomField[]>this.value)?.length) { return; }
    const inspectionModal = await this.modalController.create({
      cssClass: 'parascope-full-modal',
      backdropDismiss: false,
      component: CustomFormPage,
      id: 'customFields',
      componentProps: {
        customForm: this.value,
        onComplete: async (customFormResults: InspectionItemResult[]) =>
          await this.submitCustomFormResults(customFormResults),
      },
    });
    await inspectionModal.present();
    const dialog = inspectionModal.shadowRoot.querySelector('[role="dialog"]');
    dialog.setAttribute('aria-label', 'Custom Fields');
  }

}
